

































import { IServerModel, IServeOfflinePayModel } from "@/model";
import { Vue, Component } from "vue-property-decorator";
import { SkcServerOrderService } from "@/services";
import { ReserveType } from "src/enums";

@Component
export default class EditMemberTagForm extends Vue {

   /**
     * 获取平台服务
     * @private
     * @return SkcServerOrderService
     */
    private _skcServerOrderService: SkcServerOrderService;

     /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get skcServerOrderService(): SkcServerOrderService
    {
        if(!this._skcServerOrderService)
        {
            this._skcServerOrderService = this.$serviceProvier.resolve<SkcServerOrderService>(SkcServerOrderService);
        }

        return this._skcServerOrderService;
    }

  /**
   * 当前表单
   * @protected
   * @returns string
   */
  protected get $voucher(): any {
    return this.$refs["voucher"];
  }

  /**
   * 表单验证规则
   * @protected
   * @return any
   */
  protected rules: any = {
     accountName: [{ required: true, message: "请输入汇款户名！", trigger: "blur" }],
     remittanceAccount: [{ required: true, message: "请输入汇款账号！", trigger: "blur" }],
     remittanceTime: [{ required: true, message: "请选择汇款时间！", trigger: "change" }],
  };

  /**
   * 表单数据
   * @protected
   * @return IAppModel
   */
  protected formData: IServeOfflinePayModel = {
    orderId: 0,
    remittanceAmount: 0,
    accountName: "",
    remittanceAccount:"",
    remittanceTime: ""
  };

  /**
   * labelCol
   * @protected
   * @return any
   */
  protected labelCol: any = {
    xs: { span: 24 },
    sm: { span: 5 },
  };

  /**
   * wrapperCol
   * @protected
   * @return any
   */
  protected wrapperCol: any = {
    xs: { span: 24 },
    sm: { span: 15 },
  };

  /**
   * visible
   * @protected
   * @return boolean
   */
  protected visible: boolean = false;

  /**
   * confirmLoading
   * @protected
   * @return boolean
   */
  protected confirmLoading: boolean = false;

  /**
   * visibleDef
   * @protected
   * @return boolean
   */
  protected visibleDef: boolean = false;

  /**
   * 编辑弹窗
   */
  protected show(record: IServerModel): void {
    this.visible = true;
    setTimeout(() => {
      this.formData.orderId = record.id;
      this.formData.remittanceAmount = record.price;
    }, 100);
  }

  /**
   * 表单提交
   */
  protected handleSubmit() {
    this.confirmLoading = true;
    this.$voucher.validate(async (valid: boolean) => {
      if (valid) {
        try {
          await this.skcServerOrderService.offlinePay(this.formData);
          this.$message.success("凭证信息提交成功!");
          this.visible = false;
          this.confirmLoading = false;
          this.$emit("ok", this.formData.orderId);
        } catch {
          this.$message.error("凭证信息提交失败!");
        } finally {
          this.confirmLoading = false;
        }
      } else {
        this.confirmLoading = false;
      }
    });
  }

  /**
   * 表单取消
   * @protected
   * @return boolean
   */
  protected handleCancel() {
    this.$voucher.resetFields();
    this.visible = false;
  }
}
